import script from "./KpiGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./KpiGrid.vue?vue&type=script&setup=true&lang=ts"

import "./KpiGrid.vue?vue&type=style&index=0&id=5223a7c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5223a7c5"]])

export default __exports__